import { format, parseISO } from 'libs/dates'
import { routes } from 'config/routes'
import { useTranslation } from 'libs/i18n'
import { NavLink } from 'libs/router'
import { Currency } from 'shared/components'
import type { CardTableColumn } from 'styles/table'

const numeric = 'block text-right tabular-nums'

export const useColumns = (): CardTableColumn[] => {
	const { t } = useTranslation()

	return [
		{
			label: t('Date'),
			width: '110px',
			renderCell: (item: any) => (
				<NavLink className="font-medium text-primary hover:underline" to={routes.saleEdit(item.id)}>
					{format(parseISO(item.created), 'dd.MM.yyyy')}
				</NavLink>
			)
		},
		{
			label: t('Product'),
			width: 'minmax(160px, 1fr)',
			renderCell: (item: any) => (
				<span className="block truncate font-medium">{item.product_name}</span>
			)
		},
		{
			label: t('Reference'),
			width: '100px',
			renderCell: (item: any) => (
				<span className="text-muted-foreground">{item.receipt_reference}</span>
			)
		},
		{
			label: t('Quantity'),
			width: '80px',
			align: 'right',
			renderCell: (item: any) => <span className={numeric}>{item.quantity}</span>
		},
		{
			label: t('Total'),
			width: '110px',
			align: 'right',
			renderCell: (item: any) => (
				<Currency className={`${numeric} font-semibold`} price={item.total} />
			)
		}
	]
}
